// extracted by mini-css-extract-plugin
export default {"wrapper":"l1-z"};